import { PaintColorInfo } from "@omni/types/api/paintColors/bff/shared/paintColorInfo.model";
import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";

export enum FeatureCodes {
    FinishFeatureCode = "Hubo_Classification_Catalog/GPC/10003874.4.027",
    VolumeFeatureCode = "Hubo_Classification_Catalog/GPC/10003874.hubo_att_inhoudliter",
    CoverageFeatureCode = "Hubo_Classification_Catalog/GPC/10003874.4.362"
}

export type PaintConfiguratorWizardState = {
    family?: string;
    color?: PaintColorInfo;
    finish?: string;
    volume?: string;
    product?: Product<ProductFieldSet.Full>;
};

export type PaintConfiguratorWizardStepMeta = {
    name: string;
};

export type FeatureInfo = {
    name: string;
    value: string;
};

export type VolumeInfo = {
    volume: FeatureInfo;
    coverage: FeatureInfo;
};
